import { ChangeDetectionStrategy, Component, input } from '@angular/core';

export type LoaderSize = 'sm' | 'md' | 'lg';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ui-loader',
  styleUrl: './loader.scss',
  templateUrl: './loader.html',
})
export class LoaderComponent {
  /** Taille du spinner. */
  readonly size = input<LoaderSize>('md');

  /** Texte d'accompagnement affiché à côté du spinner. */
  readonly label = input('');

  /** Le loader recouvre son conteneur parent (position absolue). */
  readonly overlay = input(false);
}
